export default __webpack_public_path__ + "static/comparisons-team--mobile-7cc9cf1a80da7f17e972f98b98d94dcd.webp";